// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const videoViewsHistoryConfig = {
    title: 'chart.linkedin.video_views_history',
    margin: { left: -20, right: 25 },
    noLegend: true,
    name: {
        date: 'date',
        value: 'chart.linkedin.video_views_history_name'
    },
    id: 'video_views_history',
    color: {
        value: 'purple'
    },
    tooltipTranslation: {
        token: 'chart.facebook.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
